import { UrlRouter } from '@uirouter/core'
import * as uirouter from '@uirouter/core/lib'
import angular from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { $app } from './play-candidato-mod'

declare var __RECAPTCHASITEKEY__: string

export class CandidatoConfig {
  debugtoggle = true
  debugforce = false
  debug = false
}

$app.service('CandidatoCfg', CandidatoConfig)

$app.config(
  (
    $stateProvider: angular.ui.IStateProvider,
    $urlRouterProvider: angular.ui.IUrlRouterProvider,
    $urlServiceProvider: UrlRouter,
    $locationProvider: ng.ILocationProvider,
    $compileProvider: ng.ICompileProvider,
    vcRecaptchaServiceProvider: any
  ) => {
    vcRecaptchaServiceProvider.setSiteKey(__RECAPTCHASITEKEY__)
    // vcRecaptchaServiceProvider.setTheme('---- light or dark ----')
    // vcRecaptchaServiceProvider.setStoken('--- YOUR GENERATED SECURE TOKEN ---')
    // vcRecaptchaServiceProvider.setSize('---- compact, normal or invisible ----')
    // vcRecaptchaServiceProvider.setType('---- audio or image ----')
    // vcRecaptchaServiceProvider.setLang('---- language code ----')

    if (false) {
      $compileProvider.debugInfoEnabled(false)
      $compileProvider.commentDirectivesEnabled(false)
      $compileProvider.cssClassDirectivesEnabled(false)
    }

    // esto es para ngupgrade
    // $urlServiceProvider.deferIntercept()

    $locationProvider.html5Mode(false)

    $urlRouterProvider.otherwise('/c/s')

    $stateProvider.state('root', {
      url: '/',
      component: 'playApp',
      onEnter: () => {
        console.log('enter playApp')
      },
    })

    $stateProvider.state('app', {
      url: '/app',
      component: 'playApp',
      onEnter: () => {
        console.log('enter playApp app')
      },
    })

    $stateProvider.state('app.menu', {
      url: '/menu',
      component: 'panelMenu',
      onEnter: () => {
        console.log('enter panelMenu')
      },
    })

    $stateProvider.state('app.formular', {
      url: '/form',
      component: 'panelFormular',
      onEnter: () => {
        console.log('enter panelFormular')
      },
    })

    $stateProvider.state('app.preguntas', {
      url: '/q',
      component: 'panelPreguntas',
      onEnter: () => {
        console.log('enter panelPreguntas')
      },
    })

    $stateProvider.state('view', {
      url: '/view',
      template: '<ui-view></ui-view>',
      resolve: {
        // user: ($log: angular.ILogService, $stateParams: ng.ui.IStateParamsService, $state: ng.ui.IStateService, AccesoDatos: AccesoDatos) => {
        //     return AccesoDatos.Login_CLIENT.userDetails().then(login => login, error => {
        //         //
        //         $log.info("sin login")
        //         $state.go("priv.login")
        //     })
        // }
      },
      onEnter: ($state: ng.ui.IStateService) => {
        console.log('enter view')

        // $state.go("priv.login")
      },
      // redirectTo: () => "priv.login"
    })

    $stateProvider.state('view.cv', {
      url: '/cvv/{i}',
      component: 'panelCvView',
      // template: `<panel-cv cv="$resolve.cv"> </panel-cv>`,
      resolve: {
        cv: (
          $stateParams: ng.ui.IStateParamsService, //
          AccesoDatos: AccesoDatos
        ) => {
          return AccesoDatos.GestionCurr_CLIENT.registroCv($stateParams.i).then((cvResponse) => ({
            cv: cvResponse,
          }))
        },
      },
      onEnter: ($state: ng.ui.IStateService) => {
        console.log('enter view')

        // $state.go("priv.login")
      },
      // redirectTo: () => "priv.login"
    })

    $stateProvider.state('priv', {
      url: '/priv',
      template: '<ui-view></ui-view>',
      resolve: {
        // user: ($log: angular.ILogService, $stateParams: ng.ui.IStateParamsService, $state: ng.ui.IStateService, AccesoDatos: AccesoDatos) => {
        //     return AccesoDatos.Login_CLIENT.userDetails().then(login => login, error => {
        //         //
        //         $log.info("sin login")
        //         $state.go("priv.login")
        //     })
        // }
      },
      onEnter: ($state: ng.ui.IStateService) => {
        console.log('enter priv')

        // $state.go("priv.login")
      },
      redirectTo: () => 'priv.login',
    })

    $stateProvider.state('priv.login0', {
      url: '/login',
      redirectTo: () => 'priv.login',
    })

    $stateProvider.state('priv.login', {
      url: '/loginpriv',
      component: 'loginMain',
      onEnter: () => {
        console.log('enter login')
      },
    })

    $stateProvider.state('priv.main', {
      url: '/p',
      component: 'privMain',
      resolve: {
        usercfg: (
          $log: angular.ILogService,
          $stateParams: ng.ui.IStateParamsService,
          $state: ng.ui.IStateService,
          appConfigService: AppConfigService
        ) => {
          return appConfigService.leerUserConfig().then(
            (login) => login,
            (error) => {
              //
              $log.info('sin login')
              $state.go('priv.login')
            }
          )
        },
      },
      onEnter: () => {
        console.log('enter priv')
      },
      redirectTo: () => 'priv.main.ultimos2',
      // redirectTo: () => "priv.main.curriculums"
    })

    $stateProvider.state('priv.main.flex', {
      // url: "/pf",
      template: '<ui-view class="flex flex-grow flex-col"></ui-view>',
      resolve: {},
      onEnter: () => {
        console.log('enter priv flex')
      },
      redirectTo: () => 'priv.main.ultimos2',
      // redirectTo: () => "priv.main.curriculums"
    })

    $stateProvider.state('priv.main.ultimos', {
      url: '/ultimos',
      component: 'listaUltimosCurriculums',
      resolve: {
        filtros: () => false,
      },
      onEnter: () => {
        console.log('enter listaUltimosCurriculums')
      },
    })

    $stateProvider.state('priv.main.ultimos2', {
      url: '/last',
      component: 'listaUltimosCurriculums',
      resolve: {
        filtros: () => true,
      },
      onEnter: () => {
        console.log('enter listaUltimosCurriculums2')
      },
    })

    $stateProvider.state('priv.main.myforms', {
      url: '/mylast',
      component: 'listaMisFormInternos',
      resolve: {
        filtros: () => true,
      },
      onEnter: () => {
        console.log('enter listaMisFormInternos')
      },
    })

    $stateProvider.state('priv.main.intro', {
      url: '/intro',
      component: 'panelIntro',
      onEnter: () => {
        console.log('enter panelIntro')
      },
    })

    $stateProvider.state('priv.main.menu', {
      url: '/menu',
      component: 'panelMenu',
      onEnter: () => {
        console.log('enter panelMenu')
      },
    })

    $stateProvider.state('priv.main.formular', {
      url: '/form/:idform?',
      component: 'panelFormular',
      resolve: {
        idform: ($stateParams: ng.ui.IStateParamsService) => $stateParams.idform,
      },
      onEnter: () => {
        console.log('enter panelFormular')
      },
    })

    $stateProvider.state('priv.main.preguntas', {
      url: '/q',
      component: 'panelPreguntas',
      onEnter: () => {
        console.log('enter panelPreguntas')
      },
    })

    $stateProvider.state('priv.main.estados', {
      url: '/st',
      component: 'panelEstados',
      onEnter: () => {
        console.log('enter panelEstados')
      },
    })

    $stateProvider.state('priv.main.flex.docreqs', {
      url: '/docreq',
      component: 'panelDocRequirements',
      onEnter: () => {
        console.log('enter panelDocReqs')
      },
    })

    $stateProvider.state('priv.main.flex.docnotif', {
      url: '/docnotif',
      component: 'panelDocNotifications',
      onEnter: () => {
        console.log('enter panelDocNotifs')
      },
    })

    $stateProvider.state('priv.main.mainquestions', {
      url: '/mq',
      component: 'panelMainQuestions',
      onEnter: () => {
        console.log('enter panelMainQuestions')
      },
    })

    $stateProvider.state('priv.main.curriculums', {
      url: '/curr',
      component: 'panelCurriculums',
      onEnter: () => {
        console.log('enter panelCurriculums')
      },
    })

    $stateProvider.state('priv.main.deletecv', {
      url: '/del',
      component: 'panelDeleteCurriculums',
      resolve: {
        filtros: () => true,
      },
      onEnter: () => {
        console.log('enter panelDeleteCurriculums')
      },
    })

    $stateProvider.state('priv.main.historic', {
      url: '/hist',
      component: 'panelBusquedaHistoric',
      resolve: {
        filtros: () => true,
      },
      onEnter: () => {
        console.log('enter panelBusquedaHistoric')
      },
    })

    $stateProvider.state('priv.main.historic_rel', {
      url: '/hist_rel',
      component: 'panelCoincidenciasHistoric',
      resolve: {
        filtros: () => true,
      },
      onEnter: () => {
        console.log('enter panelCoincidenciasHistoric')
      },
    })

    $stateProvider.state('priv.cvprint', {
      url: '/cvprint/{i}',
      component: 'panelCvPrint',
      onEnter: () => {
        console.log('enter panelCvPrint')
      },
      resolve: {
        cv: (
          $stateParams: ng.ui.IStateParamsService, //
          AccesoDatos: AccesoDatos
        ) => {
          return AccesoDatos.GestionCurr_CLIENT.registroCv($stateParams.i).then((cvResponse) => ({
            cv: cvResponse,
          }))
        },
      },
    })

    $stateProvider.state('priv.cvpdf', {
      url: '/cvfic/{i}',
      component: 'panelCvPdf',
      onEnter: () => {
        console.log('enter panelCvPdf')
      },
      resolve: {
        cv: (
          $stateParams: ng.ui.IStateParamsService, //
          AccesoDatos: AccesoDatos
        ) => {
          return AccesoDatos.GestionCurr_CLIENT.registroCv($stateParams.i).then((cvResponse) => ({
            cv: cvResponse,
          }))
        },
      },
    })

    $stateProvider.state('priv.main.cv', {
      url: '/cv?i',
      template: `
                <sidebar-panel class="panel--cv" visible="true">
                <if-dev>-- {{ $ctrl.panelcv.$visible }} --</if-dev>

                <panel-cv cv="$resolve.cv"> </panel-cv>
                </sidebar-panel>`,
      // component: "panelCv",
      onEnter: () => {
        console.log('enter panelCurriculums')
      },
      resolve: {
        cv: (
          $stateParams: ng.ui.IStateParamsService, //
          AccesoDatos: AccesoDatos
        ) => {
          return AccesoDatos.GestionCurr_CLIENT.registroCv($stateParams.i).then((cvResponse) => ({
            cv: cvResponse,
          }))
        },
      },
    })

    $stateProvider.state('cuestionarios', {
      url: '/c',
      template: '<ui-view></ui-view>',
      onEnter: ($location: ng.ILocationService) => {
        console.log('enter cuestionarios', $location.search())

        $('body').addClass(`bg-caxton container-md cand--public`)
      },
      // redirectTo: () => "priv.main.curriculums"
    })

    $stateProvider.state('cuestionarios.startpubl', {
      url: '/s/{idmenu}?v',
      params: { idmenu: { squash: true, value: null } },
      component: 'startMenu',
      resolve: {
        idmenu: ($stateParams: ng.ui.IStateParamsService) => $stateParams.idmenu,
        version: ($stateParams: ng.ui.IStateParamsService) => $stateParams.v,
        accesoPublico: () => true,
        params: ($document: ng.IDocumentService) => {
          let search = document.location.search

          var params = {} as { [v: string]: any }

          if (search) {
            new URLSearchParams(window.location.search.substring(1)).forEach((val, key) => {
              params[key] = val
            })
          }

          return params
        },
      },
      onEnter: () => {
        console.log('enter startMenu')
      },
    })

    $stateProvider.state('cuestionarios.priv', {
      url: '/priv',
      template: '<ui-view></ui-view>',
      onEnter: ($location: ng.ILocationService) => {
        console.log('enter cuestionarios priv', $location.search())

        $('body').addClass(`bg-caxton container-md cand--public`)
      },
      resolve: {
        usercfg: (
          $log: angular.ILogService,
          $stateParams: ng.ui.IStateParamsService,
          $state: ng.ui.IStateService,
          appConfigService: AppConfigService
        ) => {
          return appConfigService.leerUserConfig().then(
            (login) => login,
            (error) => {
              //
              $log.info('sin login')
              $state.go('cuestionarios.priv.login')
            }
          )
        },
      },
      redirectTo: () => 'cuestionarios.priv.login',
      // redirectTo: () => "priv.main.curriculums"
    })

    $stateProvider.state('cuestionarios.priv.login', {
      url: '/login',
      component: 'loginMain',
      resolve: {
        seccionCuestionarios: () => true,
      },
      onEnter: () => {
        console.log('enter login cuestionarios')
      },
    })

    $stateProvider.state('cuestionarios.priv.startpriv', {
      url: '/s/{idmenu}?v',
      params: { idmenu: { squash: true, value: null } },
      component: 'startMenu',
      resolve: {
        idmenu: ($stateParams: ng.ui.IStateParamsService) => $stateParams.idmenu,
        version: ($stateParams: ng.ui.IStateParamsService) => $stateParams.v,
        accesoPublico: () => false,
        params: ($document: ng.IDocumentService) => {
          let search = document.location.search

          var params = {} as { [v: string]: any }

          if (search) {
            new URLSearchParams(window.location.search.substring(1)).forEach((val, key) => {
              params[key] = val
            })
          }

          return params
        },
      },
      onEnter: () => {
        console.log('enter startMenu')
      },
    })

    $stateProvider.state('cuestionarios.start2', {
      url: '/s2/{idform}',
      params: { idform: { squash: true, value: null } },
      component: 'startMenu',
      resolve: {
        idform: ($stateParams: ng.ui.IStateParamsService) => $stateParams.idform,
      },
      onEnter: () => {
        console.log('enter startMenu')
      },
    })
  }
)

$app.run(
  (
    $rootScope: angular.IRootScopeService,
    $log: ng.ILogService,
    $transitions: uirouter.TransitionService,
    $location: angular.ILocationService,
    CandidatoCfg: CandidatoConfig
  ) => {
    CandidatoCfg.debug = $location.search().dev == 1 || _paramDev_1()

    if (CandidatoCfg.debugforce && !CandidatoCfg.debug) {
      $('body').toggleClass('hide__dev')
    }

    $transitions.onError({}, (trans) => {
      console.log('==================> error', trans, $rootScope)
    })

    $transitions.onSuccess({}, (trans) => {
      console.log('---------------> onSuccess', trans, $rootScope, $transitions)
    })

    $transitions.onEnter({}, function (transition) {
      console.log(
        'Successful enter from ' + transition.from().name + ' to ' + transition.to().name,
        CandidatoConfig,
        $location.search().dev
      )
    })
  }
)

function _paramDev_1() {
  try {
    let search = document.location.search
    let params = new URLSearchParams(search)

    return params.get('dev') == '1'
  } catch (e) {
    return false
  }
}
